import * as types from "./types";

export default appReducer => (state, action) => {
  if (action.type === types.REHYDRATE_STATE) {
    state = action.payload;
  } else if (action.type === types.CLEAR_STATE) {
    if (!action.payload.length) state = undefined;
    else action.payload.forEach(chunk => (state[chunk] = undefined));
  }

  return appReducer(state, action);
};
